import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { FetcherService } from './fetcher/fetcher.service';
import { GetPartPricingsForPricingResponsePayload } from '@cpak/adp-cpak-pricing-service-shared';

@Injectable({
  providedIn: 'root',
})
export class PricingApiService {
  private _url = '/api/pages/quotes/';

  constructor(private fetcher: FetcherService) {}

  public getPartPricingForPricing(body: unknown): Observable<GetPartPricingsForPricingResponsePayload | null> {
    return this.fetcher.post(`${this._url}partPricingForPricing`, body);
  }
}
